<div [attr.data-cy]="chipDataCy()" class="box">
    <app-tooltip [dynamic]="false" [message]="retrieveTooltipToApply(templateTooltip)">
        <span class="text" data-cy="chip-label">{{label}}</span>
    </app-tooltip>
    <span (click)="onDeleteClick()" class="iwp-icon-gen_close close" data-cy="chip-close-button"></span>
</div>

<ng-template #templateTooltip>
    <ng-container *ngTemplateOutlet="tooltipTemplate; context: {context: value}"></ng-container>
</ng-template>
